module.exports = __webpack_public_path__ + "static/media/newLogo.dae9ceb8.svg";